export const If = ({ children, condition }) => condition ? children : null 